<template>
  <div class="vip-detail-integral">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="vipDetailIntegralInfo.integrals"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="integralId"
          :label="$t('vipDetailIntegral.id')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="integralName"
          :label="$t('vipDetailIntegral.accountName')"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailIntegral.objectType')"
          align="center"
        >
          <template #default="{row}">
            {{ row.objType === '7007' ? $t('vipDetailIntegral.merchant') : $t('vipDetailIntegral.user') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="objId"
          :label="$t('vipDetailIntegral.userId')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="link"
          :label="$t('vipDetailIntegral.phone')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('vipDetailIntegral.points')"
          align="center"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="margin-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShopLinkIntegral } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailIntegral',
  data() {
    return {
      vipDetailIntegralInfo: {
        integrals: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailIntegralInfo.link = data.tel
      this.loadIntegralData()
    },
    loadIntegralData() {
      if (!this.vipDetailIntegralInfo.link) return
      
      this.loading = true
      const params = {
        link: this.vipDetailIntegralInfo.link,
        objType: '6006',
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getShopLinkIntegral(params)
        .then(res => {
          this.vipDetailIntegralInfo.integrals = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取积分数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadIntegralData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadIntegralData()
    }
  }
}
</script>

<style scoped>
.vip-detail-integral {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>